export default "__VITE_ASSET__3P9Rr8VS__"